export default __webpack_public_path__ + "static/media/housing_fall_back.2766d2d7.jpg";